const ROOT = 'AGENCY_CONTRACT_V2_RATE_LINES_';

const actionTypes = {
  LOAD_HEADERS_REQUEST: `${ROOT}LOAD_HEADERS_REQUEST`,
  LOAD_HEADERS_SUCCESS: `${ROOT}LOAD_HEADERS_SUCCESS`,
  LOAD_HEADERS_ERROR: `${ROOT}LOAD_HEADERS_ERROR`,
  LOAD_LINES_REQUEST: `${ROOT}LOAD_LINES_REQUEST`,
  LOAD_LINES_SUCCESS: `${ROOT}LOAD_LINES_SUCCESS`,
  LOAD_LINES_ERROR: `${ROOT}LOAD_LINES_ERROR`,
  EXPORT_REQUEST: `${ROOT}EXPORT_REQUEST`,
  EXPORT_SETTLED: `${ROOT}EXPORT_SETTLED`,
  SIDE_CHANGED: `${ROOT}SIDE_CHANGED`,
  CLEAR_STORE: `${ROOT}CLEAR_STORE`,
} as const;

export default actionTypes;
